/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import emailjs from 'emailjs-com';
import React, { useRef, useState } from 'react';

import ModalSuccess from "./sections/ModalSuccess"
import ModalError from "./sections/ModalError"


import ContactPhoto from '../../../images/contact.jpg'
export default function Example() {
  const form = useRef();
  const [modalSuccessStatus, setModalSuccessStatus] = useState(false)
  const [modalErrorStatus, setModalErrorStatus] = useState(false)

    const sendMail = (e) => {
      e.preventDefault()
      const email = document.getElementById("email")
      const phone = document.getElementById("company")
      const topic = document.getElementById("phone")
      const message = document.getElementById("how-can-we-help")

      const formData = [email, phone, topic, message]

      emailjs.sendForm('default_service', 'ivp-asbl', form.current, "PYSXxABbbulhEYxck")
      .then((result) => {
        setModalSuccessStatus(true)
        formData.forEach(data => {
          data.value = ""
        })
      }, (error) => {
        setModalErrorStatus(true)
      });

      

      
    }


    return (
      <React.Fragment>
        <ModalSuccess 
          modalSuccessStatus={modalSuccessStatus}
          setModalSuccessStatus={setModalSuccessStatus}
        />

        <ModalError
          modalErrorStatus={modalErrorStatus}
          setModalErrorStatus={setModalErrorStatus}
        />
        <div className="relative bg-white">
          <div className="lg:absolute lg:inset-0">
            <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
              <img
                className="h-56 w-full object-cover lg:absolute lg:h-full h-full"
                src={ContactPhoto}
                alt=""
              />
            </div>
          </div>
          <div className="relative py-16 px-4 sm:py-24 sm:px-6 lg:px-8 lg:max-w-7xl lg:mx-auto lg:py-32 lg:grid lg:grid-cols-2">
            <div className="lg:pr-8">
              <div className="max-w-md mx-auto sm:max-w-lg lg:mx-0">
                <h2 className="text-red-500 text-3xl font-extrabold tracking-tight sm:text-4xl">Nous contacter</h2>
                <p className="mt-4 text-lg text-gray-500 sm:mt-3">
                  Si vous avez des questions nous concernant 
                  ou souhaitez tout simplement en savoir plus sur notre asbl, n'hésitez pas à nous contacter!
                </p>
                <form  ref={form} onSubmit={(e) => sendMail(e)} className="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8"> 
                  <div className="sm:col-span-2">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                      E-mail
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        className="block w-full shadow-sm sm:text-sm focus:ring-red-500 focus:border-red-500 border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700">
                      Numéro de téléphone
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="phone"
                        id="company"
                        autoComplete="tel"
                        className="block w-full shadow-sm sm:text-sm focus:ring-red-500 focus:border-red-500 border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <div className="flex justify-between">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                          Sujet
                      </label>
                      {/* <span id="phone-description" className="text-sm text-gray-500">
                        Optional
                      </span> */}
                    </div>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="topic"
                        id="phone"
                        
                        aria-describedby="phone-description"
                        className="block w-full shadow-sm sm:text-sm focus:ring-red-500 focus:border-red-500 border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <div className="flex justify-between">
                      <label htmlFor="how-can-we-help" className="block text-sm font-medium text-gray-700">
                          Votre message
                      </label>
                      {/* <span id="how-can-we-help-description" className="text-sm text-gray-500">
                        Max. 500 characters
                      </span> */}
                    </div>
                    <div className="mt-1">
                      <textarea
                        id="how-can-we-help"
                        name="message"
                        aria-describedby="how-can-we-help-description"
                        rows={4}
                        className="block w-full shadow-sm sm:text-sm focus:ring-red-500 focus:border-red-500 border border-gray-300 rounded-md"
                        defaultValue={''}
                      />
                    </div>
                  </div>
                  {/* <fieldset className="sm:col-span-2">
                    <legend className="block text-sm font-medium text-gray-700">Expected budget</legend>
                    <div className="mt-4 grid grid-cols-1 gap-y-4">
                      <div className="flex items-center">
                        <input
                          id="budget-under-25k"
                          name="budget"
                          defaultValue="under_25k"
                          type="radio"
                          className="focus:ring-red-500 h-4 w-4 text-red-600 border-gray-300"
                        />
                        <label htmlFor="budget-under-25k" className="ml-3">
                          <span className="block text-sm text-gray-700">Less than $25K</span>
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          id="budget-25k-50k"
                          name="budget"
                          defaultValue="25k-50k"
                          type="radio"
                          className="focus:ring-red-500 h-4 w-4 text-red-600 border-gray-300"
                        />
                        <label htmlFor="budget-25k-50k" className="ml-3">
                          <span className="block text-sm text-gray-700">$25K – $50K</span>
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          id="budget-50k-100k"
                          name="budget"
                          defaultValue="50k-100k"
                          type="radio"
                          className="focus:ring-red-500 h-4 w-4 text-red-600 border-gray-300"
                        />
                        <label htmlFor="budget-50k-100k" className="ml-3">
                          <span className="block text-sm text-gray-700">$50K – $100K</span>
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          id="budget-over-100k"
                          name="budget"
                          defaultValue="over_100k"
                          type="radio"
                          className="focus:ring-red-500 h-4 w-4 text-red-600 border-gray-300"
                        />
                        <label htmlFor="budget-over-100k" className="ml-3">
                          <span className="block text-sm text-gray-700">$100K+</span>
                        </label>
                      </div>
                    </div>
                  </fieldset> */}
                  {/* <div className="sm:col-span-2">
                    <label htmlFor="how-did-you-hear-about-us" className="block text-sm font-medium text-gray-700">
                      How did you hear about us?
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="how-did-you-hear-about-us"
                        id="how-did-you-hear-about-us"
                        className="shadow-sm focus:ring-red-500 focus:border-red-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </div> */}
                  <div className="text-right sm:col-span-2">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                      Envoyer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
  